import { Box, styled } from "@mui/material";

interface ShapeItemContainerProps {
  highlighted: boolean;
}

export const ShapeItemContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "highlighted",
})<ShapeItemContainerProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: ${({ highlighted }) =>
    highlighted ? "2px solid #ffd200" : "4px solid transparent"};
  border-radius: 10px;
  padding: 10px;
  transition: all 0.3s ease-in-out;

  &:hover {
    border: 4px solid #ffd200;
  }
`;
